module.exports = __webpack_public_path__ + "img/east-timor.a7e8ee40.png";